import React from 'react';
import styles from './LinkedContainer.module.scss';
import useAccessibleClick from '../../../common/hooks/useAccessibleClick';

const LinkedLink = ({ url, onClick }) => {
  const myRef = useAccessibleClick(onClick);

  return (
    <a ref={myRef} tabIndex={0} className={styles.url} onClick={onClick}>
      {url}
    </a>
  )
};

export default LinkedLink;